export default class EnvironmentService {

    getEnvironmentHost() {
        if (process.env.NODE_ENV === "development") {
            return "http://localhost:5001";
        }
        else {
            return window.location.origin;
        }
    }

}


// WEBPACK FOOTER //
// ./src/service/environmentService.js